import styled from 'styled-components'

const Avatar = styled('img')`
  height: 48px;
  width: 48px;
  border-radius: 50%;
`

export default Avatar
